import * as React from "react";
import TruncatedText from "shiitake";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { inject } from "mobx-react";
import { ContextStore } from "bernie-core";
import { useLocalization } from "@shared-ui/localization-context";
import { ratingDescription } from "../hotelRecentReviewsUtils";

interface ReviewTitleAndRatingProps {
  context?: ContextStore;
  rating: string;
  reviewTitle?: string;
  showReviewSuperlative?: boolean;
}

const ReviewTitleAndRating = (props: ReviewTitleAndRatingProps) => {
  const { formatText } = useLocalization();
  const ratingText = formatText("hotelRecentReviews.outOf5Rating", props.rating);
  const reviewText = props.showReviewSuperlative ? `${ratingText} ${ratingDescription(props.rating)}` : ratingText;

  return (
    <Viewport>
      <ViewSmall>
        <div className="uitk-cell all-y-padding-one">
          <div className="uitk-type-heading-500">
            <TruncatedText lines={2} renderFullOnServer={true}>
              {props.reviewTitle || formatText("hotelRecentReviews.verifiedBrandReview", props.context!.site.name)}
            </TruncatedText>
          </div>
          <div>{reviewText}</div>
        </div>
      </ViewSmall>
      <ViewMedium>
        <div className="uitk-cell all-y-padding-one">
          <div className="uitk-type-heading-500">
            <TruncatedText lines={2} renderFullOnServer={true}>
              {props.reviewTitle || formatText("hotelRecentReviews.verifiedBrandReview", props.context!.site.name)}
            </TruncatedText>
          </div>
          <div className="reviewRating uitk-type-medium uitk-type-300">{reviewText}</div>
        </div>
      </ViewMedium>
    </Viewport>
  );
};

export default inject("context")(ReviewTitleAndRating);
